import { apiClient } from '../lib/api';

export interface Lab {
  id: string;
  name: string;
  country: string | null;
  timeZone: string | null;
  status: string;
  userCount: number;
  createdAt: string;
}

export interface CreateLabRequest {
  name: string;
  country?: string;
  timeZone?: string;
}

export const labService = {
  async getLabs(): Promise<Lab[]> {
    const response = await apiClient.get<{ items: Lab[] }>('/api/v1/labs');
    return response.data.items;
  },

  async getLab(id: string): Promise<Lab> {
    const response = await apiClient.get<Lab>(`/api/v1/labs/${id}`);
    return response.data;
  },

  async createLab(data: CreateLabRequest): Promise<Lab> {
    const response = await apiClient.post<Lab>('/api/v1/labs', data);
    return response.data;
  },

  async updateLab(id: string, data: Partial<CreateLabRequest>): Promise<Lab> {
    const response = await apiClient.put<Lab>(`/api/v1/labs/${id}`, data);
    return response.data;
  },

  async deactivateLab(id: string): Promise<Lab> {
    const response = await apiClient.post<Lab>(`/api/v1/labs/${id}/deactivate`);
    return response.data;
  },
};
